export default __webpack_public_path__ + "static/media/Group8885.5332ff52.svg";